mutation CreateOrUpdateSentenceGroupCategory($id: ID, $description: String!, $order: Int) {
  createOrUpdateSentenceGroupCategory(id: $id, description: $description, order: $order) {
    ok
    errors
    sentenceGroupCategory {
      id
      description
      order
    }
  }
}
